// 전 페이지 공통 하단 문의처 — 사용자 지시(2026-08-11): 모든 페이지 하단에 표기.
export default function ContactFooter() {
  return (
    <div className="contact-foot">
      contact : <a href="mailto:valuation@deepsearch.com">valuation@deepsearch.com</a>
    </div>
  );
}
